import gql from "graphql-tag";

const GET_CURRENT_USER_QUERY = gql`
  query GetCurrentUserHook {
    currentUser {
      id
      email
      customer {
        id
        type
        verified
      }
    }
  }
`;

export default GET_CURRENT_USER_QUERY;
